import { MatrixBand } from '../HedgePlans/HedgePlanMatrixBands';
import { MatrixTermResult } from '../Matrix/MatrixTypes';

function getDecileValue(matrix: MatrixTermResult, rank: number): number | undefined {
  return matrix.weightedDeciles.find((decile) => Math.abs(decile.rank - rank) < 0.001)?.value;
}

// The matrix's ten decile bands, highest prices first, in the shape the Hedge Plan table and chart use.
export function buildSeasonalMatrixBands(matrix: MatrixTermResult): MatrixBand[] {
  return Array.from({ length: 10 }, (_, index) => {
    const low = 90 - index * 10;
    const high = low + 10;
    return {
      percentile: low,
      label: `${low === 0 ? 'Min' : `${low}%`} - ${high === 100 ? 'Max' : `${high}%`}`,
      lowValue: getDecileValue(matrix, low / 100) ?? 0,
      highValue: getDecileValue(matrix, high / 100) ?? 0,
    };
  });
}

export function getMatrixMedian(matrix: MatrixTermResult): number | undefined {
  return getDecileValue(matrix, 0.5);
}
